import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../store/authContext';

interface AdminRouteProps {
  redirectPath?: string;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ redirectPath = '/login' }) => {
  const auth = React.useContext(AuthContext) as any;
  const isAuthenticated = !!auth?.isLoggedIn;
  const isAdmin = !!auth?.isAdmin || !!auth?.isSuperAdmin;

  if (!isAuthenticated) return <Navigate to={redirectPath} replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
};

export default AdminRoute;
